import { g as getAssetPath } from './index-d3a9c8bd.js';

const hasIntersectionSupport = () => typeof window !== 'undefined' && window.IntersectionObserver;

/**
 * get stenciljs assets path based on name and size props
 * @param name
 * @param path
 */
function getUrl(name, path) {
    if (!name)
        return;
    const fileName = getFileName(name);
    return getAssetPath(path + '/' + fileName);
}
/**
 * get stripped filename to svg
 * @param name
 */
function getFileName(name) {
    if (!name)
        return;
    const fileName = name.replace(/(.)([A-Z])/g, '$1-$2').toLowerCase();
    return `${fileName}.svg`;
}
/**
 * lazy loading
 */
const observeIconElement = (lazy, el, callback) => {
    if (lazy && hasIntersectionSupport()) {
        const observer = new IntersectionObserver((data) => {
            if (data[0].isIntersecting) {
                observer.disconnect();
                callback();
            }
        }, { rootMargin: '50px' });
        observer.observe(el);
        return observer;
    }
    else {
        callback();
        return undefined;
    }
};

export { getUrl as g, observeIconElement as o };
